import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { CandidateDetail, CandidateSearchParameter } from 'types/job_candidate'
import { JobScout, JobScoutPayload } from 'types/job_scout'

const resource = 'job_scouts'

export const requests = {
  fetchScouts: (
    parameter: CandidateSearchParameter,
    page: number,
    limit: number,
  ) => {
    return axiosForGigbaseBiz.get<DataResponse<JobScout[]>>(resource, {
      params: {
        ...parameter,
        status: 1,
        page,
        limit,
      },
    })
  },
  fetchScout: (jobScoutId: string) => {
    return axiosForGigbaseBiz.get<DataResponse<CandidateDetail>>(
      `${resource}/${jobScoutId}`,
    )
  },
  sendScout: async (params: JobScoutPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<void>>(resource, {
      worker_id: params.workerId,
      job_id: params.jobId,
      message: params.message,
      worker_mind_id: params.workerMindId,
    })
  },
  cancel: async (jobScoutId: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobScoutId}/cancel`,
    )
  },
}
